<template>
	<div ref="container" style="width: 100%; height: 100%;"></div>
</template>

<script>
import GiftGoalWidget from '@/widgets/GiftGoalWidget';

export default {
	name: 'GiftGoalWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
		realData: { type: Boolean, default: false },
	},
	data() {
		return {};
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
		realData() { this._destroyWidget(); this._initWidget(); },
	},
	mounted() {
		this._initWidget();
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			this.widget = new GiftGoalWidget({
				container: this.$refs.container,
			});

			const initData = { settings: { ...this.settings }, userData: { currency_code: 'USD' } };

			if(this.realData) {
				try {
					const user = await this.$api.get('userData');
					const hash = user?.widget_hash || 'preview';
					const userData = await this.$api.get(`widget/${encodeURIComponent(hash)}/userData`).catch(() => null);
					if(userData) initData.userData = userData;
				} catch(e) { /* ignore */ }

				this._previewSubId = this.$socket.subscribe('preview', { reconnect: () => this._destroyWidget() || this._initWidget() });
			}

			await this.widget.init(initData);
		},
		_destroyWidget() {
			if(this._previewSubId != null) { this.$socket.unsubscribe(this._previewSubId); this._previewSubId = null; }
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
	},
};
</script>
